import React from "react"

import { ContentTag } from "scrivito"

import { useProductQuickInfosContext } from "./ProductQuickInfosContext"

export const ProductQuickInfosContent = React.memo(() => {
  const { quickInfos } = useProductQuickInfosContext()

  const widgets = React.useMemo(
    () => (quickInfos ? Object.values(quickInfos) : []),
    [quickInfos]
  )

  if (!quickInfos || Object.keys(quickInfos).length === 0) {
    return null
  }

  return (
    <div className="product-information-quick-infos__content">
      {widgets.map(widget => {
        return (
          <div
            key={widget.id()}
            className="product-information-quick-infos__entry"
          >
            <ContentTag
              tag="h3"
              className="product-information-quick-infos__label label label--bold"
              content={widget}
              attribute="label"
            />
            <ContentTag
              className="product-information-quick-infos__value"
              content={widget}
              attribute="text"
            />
          </div>
        )
      })}
    </div>
  )
})

ProductQuickInfosContent.displayName = "ProductQuickInfos.Content"
